import { Controller } from "@hotwired/stimulus"

/**
 * Skeleton placeholder for lazy-loaded images.
 *
 * Shows a pulsing placeholder while the image loads, then removes it.
 * Set aspect-ratio on the element to reserve space and prevent layout shift.
 *
 * Usage:
 *   <img data-controller="lazy-image" loading="lazy" src="..."
 *        style="aspect-ratio: 16/9" class="w-full" />
 */
export default class extends Controller {
  static classes = ["loading"]

  connect() {
    if (this.element.complete) return

    this.element.classList.add(...this._loadingClasses)
    this.element.addEventListener("load", () => this._onLoad(), { once: true })
  }

  _onLoad() {
    this.element.classList.remove(...this._loadingClasses)
  }

  get _loadingClasses() {
    return this.hasLoadingClass ? this.loadingClasses : ["animate-pulse", "bg-gray-200"]
  }
}
